import * as React from 'react';
import { mergeStyles } from '@cian/utils';

import { IChartLegend } from '../../types';

import * as styles from './styles.css';

interface IChartLegendProps {
  chartLegend: IChartLegend;
}

export const ChartLegend: React.FC<IChartLegendProps> = ({ chartLegend }) => {
  return (
    <div className={styles['container']}>
      <h4 className={styles['title']}>{chartLegend.title}</h4>
      <ul className={styles['legend']}>
        {chartLegend.items.map(item => (
          <li key={item.key} className={styles['legend-item']}>
            <span {...mergeStyles(styles['legend-sign'], { backgroundColor: item.color })} />
            <span>{item.name}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

ChartLegend.displayName = 'ChartLegend';
